/**
 * @generated SignedSource<<ef687f4ec271f813c7efe9d2f8386fbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BadgeKind = "emoji" | "icon" | "upload" | "%future added value";
export type LandingPageMode = "external" | "internal" | "none" | "%future added value";
export type PricingFrequency = "annually" | "monthly" | "weekly" | "%future added value";
export type PricingKind = "free" | "one_time" | "recurring" | "%future added value";
export type ProductRegistrationAvailability = "hidden" | "private" | "public" | "%future added value";
export type ProductRegistrationType = "application" | "closed" | "open" | "waitlist" | "%future added value";
export type ProductStatus = "archived" | "draft" | "published" | "unlisted" | "%future added value";
export type EditExperienceInput = {
  addEntityTags?: ReadonlyArray<CreateTagUsageInput> | null;
  adminCanLearnMode?: boolean | null;
  applicationQuestions?: ReadonlyArray<ProductQuestionInput> | null;
  badge?: BadgeInput | null;
  capacity?: number | null;
  cover?: string | null;
  coverAssetId?: string | null;
  description?: string | null;
  endDate?: string | null;
  experienceUrl?: string | null;
  id: string;
  isAutoJoined?: boolean | null;
  landingPage?: ProductLandingPageInput | null;
  landingPageUrl?: string | null;
  membershipBenefits?: ReadonlyArray<EditExperienceMembershipBenefitInput> | null;
  name?: string | null;
  registrationAvailability?: ProductRegistrationAvailability | null;
  registrationType?: ProductRegistrationType | null;
  removeEntityTagIds?: ReadonlyArray<string> | null;
  replyToEmailAddress?: string | null;
  richEditorCheckoutDescription?: string | null;
  sendAssignmentDueNotifications?: boolean | null;
  sendCourseRegistrationEmailToAttendees?: boolean | null;
  sendCourseReminderEmail?: boolean | null;
  sendEarlyAccessStartedEmail?: boolean | null;
  sendNewCommentEmail?: boolean | null;
  slug?: string | null;
  startDate?: string | null;
  status?: ProductStatus | null;
  typeTag?: TagInput | null;
  waitingRoomEndsAt?: string | null;
  waitlistCtaLabel?: string | null;
  waitlistUrl?: string | null;
};
export type BadgeInput = {
  assetId?: string | null;
  color?: string | null;
  emoji?: string | null;
  icon?: string | null;
  kind: BadgeKind;
  mediaUrl?: string | null;
};
export type TagInput = {
  color?: string | null;
  label?: string | null;
};
export type ProductLandingPageInput = {
  metaDescription?: string | null;
  metaImageAssetId?: string | null;
  metaImageUrl?: string | null;
  metaTitle?: string | null;
  mode?: string | null;
};
export type ProductQuestionInput = {
  id: string;
  isRequired: boolean;
  richEditorBody?: string | null;
  type: string;
};
export type CreateTagUsageInput = {
  id: string;
  name?: string | null;
};
export type EditExperienceMembershipBenefitInput = {
  id?: string | null;
  membershipPlanId: string;
  pricing: UpdatePricingInput;
  productId?: string | null;
};
export type UpdatePricingInput = {
  amountCents: number;
  frequency?: PricingFrequency | null;
  kind: PricingKind;
};
export type ExperienceSettingsFormMutation$variables = {
  input: EditExperienceInput;
};
export type ExperienceSettingsFormMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly adminCanLearnMode: boolean;
      readonly applicationQuestions: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly isRequired: boolean;
            readonly richEditorBody: string | null;
            readonly type: string;
          };
        }>;
      };
      readonly badge: {
        readonly color: string | null;
        readonly emoji: string | null;
        readonly icon: string | null;
        readonly kind: BadgeKind;
        readonly mediaUrl: string | null;
      } | null;
      readonly capacity: number | null;
      readonly cover: string;
      readonly description: string | null;
      readonly endDate: string | null;
      readonly endsAt: string | null;
      readonly entityTagUsages: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityTag: {
              readonly id: string;
              readonly name: string;
            };
            readonly id: string;
          };
        }>;
      };
      readonly hasPrice: boolean;
      readonly id: string;
      readonly includedInBenefits: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly membershipPlan: {
              readonly id: string;
            };
            readonly pricing: {
              readonly amountCents: number;
              readonly frequency: PricingFrequency | null;
              readonly kind: PricingKind;
            };
          };
        }>;
      } | null;
      readonly isAutoJoined: boolean;
      readonly landingPage: {
        readonly metaDescription: string | null;
        readonly metaImageUrl: string | null;
        readonly metaTitle: string | null;
        readonly mode: LandingPageMode;
      } | null;
      readonly landingPageUrl: string | null;
      readonly name: string;
      readonly organization: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"useExperienceSettingsSelectedPlans_membershipPlansFragment">;
      };
      readonly organizationId: string;
      readonly registrationAvailability: ProductRegistrationAvailability;
      readonly registrationPricing: {
        readonly amountCents: number;
        readonly basePrice: number;
        readonly frequency: PricingFrequency | null;
        readonly kind: PricingKind;
      } | null;
      readonly registrationType: ProductRegistrationType;
      readonly replyToEmailAddress: string | null;
      readonly richEditorCheckoutDescription: string | null;
      readonly sendAssignmentDueNotifications: boolean;
      readonly sendCourseRegistrationEmailToAttendees: boolean;
      readonly sendCourseReminderEmail: boolean;
      readonly sendEarlyAccessStartedEmail: boolean;
      readonly sendNewCommentEmail: boolean;
      readonly slug: string;
      readonly startDate: string | null;
      readonly startsAt: string | null;
      readonly status: ProductStatus;
      readonly typeTag: {
        readonly color: string;
        readonly label: string;
      } | null;
      readonly waitingRoomEndsAt: string | null;
      readonly waitlistCtaLabel: string | null;
      readonly waitlistUrl: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"ProductVisibilityBanner_parentPathwaysHaveDraftChildProductsFragment">;
    } | null;
  };
};
export type ExperienceSettingsFormMutation = {
  response: ExperienceSettingsFormMutation$data;
  variables: ExperienceSettingsFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emoji",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landingPageUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaTitle",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaDescription",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaImageUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitingRoomEndsAt",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendEarlyAccessStartedEmail",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "registrationAvailability",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "registrationType",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitlistUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitlistCtaLabel",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "QuestionNodeConnection",
  "kind": "LinkedField",
  "name": "applicationQuestions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuestionNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Question",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "richEditorBody",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRequired",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAutoJoined",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrice",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCents",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequency",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "RegistrationPricing",
  "kind": "LinkedField",
  "name": "registrationPricing",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "basePrice",
      "storageKey": null
    },
    (v5/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "membershipPlan",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendNewCommentEmail",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendCourseRegistrationEmailToAttendees",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendCourseReminderEmail",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendAssignmentDueNotifications",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "replyToEmailAddress",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorCheckoutDescription",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adminCanLearnMode",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "EntityTagUsageNodeConnection",
  "kind": "LinkedField",
  "name": "entityTagUsages",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityTagUsageNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EntityTagUsage",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "EntityTag",
              "kind": "LinkedField",
              "name": "entityTag",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExperienceSettingsFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditExperienceMutationResponse",
        "kind": "LinkedField",
        "name": "editExperience",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badge",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "typeTag",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandingPage",
                "kind": "LinkedField",
                "name": "landingPage",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MembershipBenefitNodeConnection",
                "kind": "LinkedField",
                "name": "includedInBenefits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MembershipBenefitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MembershipBenefit",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v37/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useExperienceSettingsSelectedPlans_membershipPlansFragment"
                  }
                ],
                "storageKey": null
              },
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProductVisibilityBanner_parentPathwaysHaveDraftChildProductsFragment"
              },
              (v45/*: any*/)
            ],
            "storageKey": null
          },
          (v46/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExperienceSettingsFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditExperienceMutationResponse",
        "kind": "LinkedField",
        "name": "editExperience",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badge",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "typeTag",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v7/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandingPage",
                "kind": "LinkedField",
                "name": "landingPage",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MembershipBenefitNodeConnection",
                "kind": "LinkedField",
                "name": "includedInBenefits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MembershipBenefitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MembershipBenefit",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v5/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v37/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": "membershipPlans",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "membership_plan"
                      }
                    ],
                    "concreteType": "ProductNodeConnection",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v10/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isFreeMembership",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MembershipBenefitNodeConnection",
                                "kind": "LinkedField",
                                "name": "membershipBenefits",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalCount",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Pricing",
                                "kind": "LinkedField",
                                "name": "pricing",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "products(type:\"membership_plan\")"
                  }
                ],
                "storageKey": null
              },
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductNodeConnection",
                "kind": "LinkedField",
                "name": "parentPathwayProducts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasDraftChildProducts",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v45/*: any*/)
            ],
            "storageKey": null
          },
          (v46/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "851e0e85f576755cd28bb5dd13e9dd1e",
    "id": null,
    "metadata": {},
    "name": "ExperienceSettingsFormMutation",
    "operationKind": "mutation",
    "text": "mutation ExperienceSettingsFormMutation(\n  $input: EditExperienceInput!\n) {\n  response: editExperience(input: $input) {\n    node {\n      id\n      organizationId\n      slug\n      badge {\n        kind\n        icon\n        color\n        emoji\n        mediaUrl\n        id\n      }\n      name\n      description\n      cover\n      typeTag {\n        label\n        color\n        id\n      }\n      landingPageUrl\n      landingPage {\n        mode\n        metaTitle\n        metaDescription\n        metaImageUrl\n        id\n      }\n      status\n      startDate\n      endDate\n      startsAt\n      endsAt\n      waitingRoomEndsAt\n      sendEarlyAccessStartedEmail\n      registrationAvailability\n      registrationType\n      waitlistUrl\n      waitlistCtaLabel\n      applicationQuestions {\n        edges {\n          node {\n            id\n            richEditorBody\n            type\n            isRequired\n          }\n        }\n      }\n      isAutoJoined\n      capacity\n      hasPrice\n      registrationPricing {\n        amountCents\n        basePrice\n        kind\n        frequency\n      }\n      includedInBenefits {\n        edges {\n          node {\n            id\n            pricing {\n              amountCents\n              frequency\n              kind\n              id\n            }\n            membershipPlan {\n              id\n            }\n          }\n        }\n      }\n      organization {\n        id\n        ...useExperienceSettingsSelectedPlans_membershipPlansFragment\n      }\n      sendNewCommentEmail\n      sendCourseRegistrationEmailToAttendees\n      sendCourseReminderEmail\n      sendAssignmentDueNotifications\n      replyToEmailAddress\n      richEditorCheckoutDescription\n      adminCanLearnMode\n      ...ProductVisibilityBanner_parentPathwaysHaveDraftChildProductsFragment\n      entityTagUsages {\n        edges {\n          node {\n            id\n            entityTag {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment MembershipPlanExperiencePricingListItemFragment on Product {\n  id\n  name\n  cover\n  membershipBenefits {\n    totalCount\n  }\n  pricing {\n    id\n    amountCents\n    frequency\n    kind\n  }\n}\n\nfragment ProductVisibilityBanner_parentPathwaysHaveDraftChildProductsFragment on Product {\n  parentPathwayProducts {\n    edges {\n      node {\n        id\n        hasDraftChildProducts\n      }\n    }\n  }\n}\n\nfragment useExperienceSettingsSelectedPlans_membershipPlansFragment on Organization {\n  id\n  membershipPlans: products(type: \"membership_plan\") {\n    edges {\n      node {\n        id\n        name\n        cover\n        isFreeMembership\n        membershipBenefits {\n          totalCount\n        }\n        pricing {\n          id\n          amountCents\n          frequency\n          kind\n        }\n        ...MembershipPlanExperiencePricingListItemFragment\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "050270142abd4a0808c3bf68b8f8b30b";

export default node;
